// Third party
import moment from 'moment';
import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

// Utils
import { formatLocalizedString, formatMessage, FormattedMessage } from '../../../utils/i18n';

// Components
import { DestructiveButton } from '../buttons';
import NotificationBody from '../notification/NotificationBody';

// Redux
import { AnnouncementSource, UserAnnouncement } from '../../../redux/modules/types/announcements';

type Props = {
  announcement: UserAnnouncement;
  onReadMore: () => void;
  onVisible: (id: string) => void;
};

export class NotificationItem extends Component<Props> {
  renderDetails = () => {
    const { notificationDate, source, read } = this.props.announcement;
    return (
      <div className="notification-details">
        <span className="me-2">{moment(notificationDate).format(formatMessage('Common.DateFormats.DateWithTime'))}</span>
        {source === AnnouncementSource.ENTERPRISE && (
          <i
            className="icon-enterprise me-2"
            title={formatMessage('AnnouncementsAdvisor.EnterpriseAnnouncement')}
            aria-label={formatMessage('AnnouncementsAdvisor.EnterpriseAnnouncement')}
          />
        )}
        {read && <i className="icon-checkmark" />}
      </div>
    );
  };

  render() {
    const {
      announcement,
      announcement: { _id, title, read, acknowledged, acknowledgmentRequired },
    } = this.props;

    return (
      <VisibilitySensor
        onChange={isVisible => {
          if (isVisible && !read && !acknowledgmentRequired) {
            this.props.onVisible(_id);
          }
        }}
      >
        <div className="notification-card">
          <div className="notification-status">
            {!read && (
              <span className="unread-dot" title={formatMessage('AnnouncementsAdvisor.Unread')} aria-label={formatMessage('AnnouncementsAdvisor.Unread')} />
            )}
            {acknowledgmentRequired && <i className="icon-ds-warning" aria-hidden />}
            {!acknowledgmentRequired && <i className="icon-info-outline" aria-hidden />}
          </div>
          <div className="notification-content">
            <h4>{formatLocalizedString(title)}</h4>

            <NotificationBody item={announcement} onReadMore={this.props.onReadMore} />

            {acknowledgmentRequired && !acknowledged && (
              <DestructiveButton compact className="with-border mb-3" onClick={this.props.onReadMore}>
                <FormattedMessage id="AnnouncementsAdvisor.ReadAndAcknowledge" />
              </DestructiveButton>
            )}
            {this.renderDetails()}
          </div>
        </div>
      </VisibilitySensor>
    );
  }
}
